import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfigService } from '../../services/config/config.service';
import { FlashMessagesService } from '../../services/flash-messages/flash-messages.service';
import { Site } from '../../services/sites/site.model';
import { SitesService } from '../../services/sites/sites.service';

@Component({
    selector: 'app-select-site',
    templateUrl: './select-site.component.html',
    styleUrls: ['./select-site.component.css']
})
export class SelectSiteComponent implements OnDestroy {
    @Input() disabled: boolean;
    messageIds = {
        httpError: <string>null
    };
    selectedSite: Site;
    sites: Site[];
    @Output() siteSelected = new EventEmitter<Site>();

    constructor(activatedRoute: ActivatedRoute,
                configService: ConfigService,
                private flashMessagesService: FlashMessagesService,
                private sitesService: SitesService) {

        // Routing to the same component doesn't recreate the component so we must subscribe to params changes.
        activatedRoute.params.subscribe(params => {
            const siteParam = params['site'];
            if (siteParam) {
                this.loadSites(siteParam);
            }
        });

        // Load defaults from index.html (for when there is nothing in the url).
        const site = activatedRoute.snapshot.paramMap.get('site');

        if (!site && configService.config.defaultSite) {
            this.loadSites(configService.config.defaultSite);
        }
        sitesService.all().subscribe(result => this.sites = result.sort(this.compareSite));
    }

    loadSites(site: string): void {
        this.sitesService.get(site).subscribe(result => {
            this.selectSite(result);
        }, error => {
            this.messageIds.httpError = this.flashMessagesService.addMessageFor(error);
        });
    }

    ngOnDestroy(): void {
    }

    selectSite(site: Site): void {
        this.selectedSite = site;
        this.siteSelected.emit(site);
    }

    private compareSite(site1: Site, site2: Site): number {
        if (site1.siteNumber === site2.siteNumber) {
            return 0;
        }

        if (site1.siteNumber > site2.siteNumber) {
            return 1;
        }

        return -1;
    }
}
